/** The ids a team dropdown option can be keyed by. */
export interface TeamValueRef {
  id?: string | null
  uid?: string | null
  team_player_roster_id?: string | null
}

/**
 * The value a team's dropdown option carries: its roster row when it registers
 * through one, else its own id. Must stay in step with the options built by
 * `getTeamDropdownOptions`.
 */
export const teamOptionValue = (
  team: TeamValueRef | null | undefined
): string | undefined =>
  team?.team_player_roster_id || team?.uid || team?.id || undefined

/**
 * The team in `teams` a held selection refers to, matched on the same option
 * value the dropdown uses. Null when nothing is held or it is not in the list.
 */
export const findHeldTeam = <T extends TeamValueRef>(
  teams: T[] | null | undefined,
  held: TeamValueRef | null | undefined
): T | null => {
  const value = teamOptionValue(held)
  if (!value) {
    return null
  }
  return (teams ?? []).find((team) => teamOptionValue(team) === value) ?? null
}
